import style from './News.module.css';
import {NewsEvent} from "../stores/events";

export default function News(props: {news: NewsEvent[]}) {

    return (
        <div className="px-4 py-2">
            <h2 className={`text-2xl ${style.mainTitle}`}>News</h2>
            <div className="py-1">
                <div className="flex overflow-x-scroll no-scrollbar">
                    {
                        props.news.map((news, index) =>
                            <span
                                className="mr-6 flex-none w-36 max-w-36"
                                key={index}
                            >
                                <img
                                    src={news.thumbnail}
                                    alt={news.description}
                                    className="w-36 h-28 object-cover"
                                />
                                <div className="pt-3 leading-5 text-sm">
                                    {news.influence.symbol || news.topic}
                                </div>
                                <div className="font-bold h-32 max-h-32
                                border-b border-black border-dotted
                                leading-5">
                                    {news.title}
                                </div>
                            </span>
                        )
                    }
                </div>
            </div>
        </div>
    );

}